<template>
  <div class="container text-center">
    <h1 class="display-1 font-weight-light" style="color:#007db6">{{ title }}</h1>
    <p class="mt-3 ne-body">{{ subtitle }}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      title: 'mapTemplate/geographyTitle',
      subtitle: 'mapTemplate/geographySubtitle'
    })
  }
};
</script>

<style lang="scss" scoped>
.ne-body {
  font-family: $ne-body-font-family;
}
</style>
